import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core';

import { WrapLegacyRouterContext } from 'ha/helpers/router';
import ErrorBoundary from './ErrorBoundary';

class AppRoot extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  // Remove the server-side injected CSS.
  componentDidMount() {
    const jssStyles = global.document.getElementById('jss-server-side');

    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }

  render() {
    return (
      <ErrorBoundary>
        <React.StrictMode>
          <WrapLegacyRouterContext>
            {this.props.children}
          </WrapLegacyRouterContext>
        </React.StrictMode>
      </ErrorBoundary>
    );
  }
}

const styles = () => ({
  '@global': {
    body: {
      margin: 0,
    },
  },
});

const AppRootWithStyles = withStyles(styles)(AppRoot);

export default AppRootWithStyles;
